import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
@Component({
  standalone: false,
  selector: "app-owp-password",
  templateUrl: "./owp-password.component.html",
  styleUrls: ["./owp-password.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwpPasswordComponent implements OnInit ,OnDestroy{
  newPasswordForm: FormGroup;
  column: LegacyAny;
  tables: LegacyAny;
  properties: LegacyAny;
  firstColumn: LegacyAny[] = [];
  secondColumn: LegacyAny[] = [];
  verifyPasswordForm: FormGroup;
  ngModelval: LegacyAny = [];
  feature12Nc = [];
  dataSet = [];
  features = [];
  schemaSet = [];
  verifyPasswordFieldValue: LegacyAny = {
    verifyPasswordInputBox1: null,
    verifyPasswordInputBox2: null,
    verifyPasswordInputBox3: null,
    verifyPasswordInputBox4: null,
  };
  passwordFieldValue: LegacyAny = {
    newPasswordInputBox1: null,
    newPasswordInputBox2: null,
    newPasswordInputBox3: null,
    newPasswordInputBox4: null,
  };
  quickConfigCustomCSS;
  setQuickConfig;
  isEdited: LegacyAny;
  inputError: LegacyAny = [];
  owpCreateFile: boolean;
  owpDefaultColor;
  submitted: boolean = false;
  resetPass: LegacyAny = false;
  pathVal: string;
  showAllPasswords: boolean = false;
  @Output() sendOwpPwd: EventEmitter<LegacyAny> = new EventEmitter();
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private ref: ChangeDetectorRef
  ) { }
  //@Input() public errorDescription: LegacyAny='Enter OEM Password';
  @Input() public TitleName: LegacyAny ='Enter OEM Password';
  @Input() public showCancelButton: boolean = true;
  @Output() cancelOwpPwd = new EventEmitter<void>();

  ngOnInit() {
    this.initNewPasswordForm();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  initNewPasswordForm() {
    // Build the four newPasswordInputBoxN controls via a loop so the shared
    // validator set only appears once.
    const controls: LegacyAny = {};
    for (let i = 1; i <= 4; i++) {
      controls[`newPasswordInputBox${i}`] = ["", this.buildPasswordFieldValidators()];
    }
    this.newPasswordForm = this.fb.group(
      controls,
      { updateOn: 'change', validators: [this.disallowAllSameExtreme()] }
    );
  }

  /** Validator array shared by every 0-255 password input field. */
  private buildPasswordFieldValidators() {
    return [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
      Validators.minLength(1),
      Validators.maxLength(3),
      Validators.max(255),
    ];
  }

  // FormGroup validator: if all four values are filled and all are 0 or all are 255 mark group invalid
  // Individual fields CAN be 0 or 255, but NOT all four at the same time
  disallowAllSameExtreme() {
    return (group: FormGroup) => {
      const c1 = group.get('newPasswordInputBox1');
      const c2 = group.get('newPasswordInputBox2');
      const c3 = group.get('newPasswordInputBox3');
      const c4 = group.get('newPasswordInputBox4');
      if (!c1 || !c2 || !c3 || !c4) { return null; }
      const vals = [c1.value, c2.value, c3.value, c4.value];
      // Ensure all have values
      if (vals.some(v => v === null || v === '')) { return null; }
      
      // Convert to numeric for comparison (allows 0, 00, 000 all as zero)
      const numericVals = vals.map(v => parseInt(v, 10));
      
      // Check if all four are zero
      if (numericVals.every(v => v === 0)) {
        return { allZero: true };
      }
      // Check if all four are 255
      if (numericVals.every(v => v === 255)) {
        return { all255: true };
      }
      return null;
    };
  }

  // Auto-advance to the next input when 3 digits entered and value within range
  onAutoAdvance(currentControlName: string, nextInput: HTMLInputElement | null) {
    const control = this.newPasswordForm.get(currentControlName);
    if (!control) { return; }
    const val: string = control.value;
    // If user pasted, trim to 3 chars
    if (val && val.length > 3) {
      control.setValue(val.substring(0,3));
    }
    if (val && val.length === 3) {
      const num = parseInt(val, 10);
      // Auto-advance for LegacyAny valid value 0-255 (including 000 and 255)
      if (!isNaN(num) && num >= 0 && num <= 255) {
        if (nextInput) {
          nextInput.focus();
          nextInput.select();
        }
      }
    }
  }

  // Handle backspace navigation: when field is empty and Backspace pressed, focus previous
  onBackspaceNavigate(event: KeyboardEvent, prevInput: HTMLInputElement | null, currentControlName: string) {
    if (event.key === 'Backspace') {
      const control = this.newPasswordForm.get(currentControlName);
      if (control && (!control.value || control.value.length === 0)) {
        if (prevInput) {
          event.preventDefault();
            prevInput.focus();
            prevInput.select();
        }
      }
    }
  }

  toggleShowAllPasswords() {
    this.showAllPasswords = !this.showAllPasswords;
  }

  onSubmit(event, controlName, formName) {
    if (formName === "newPassword") {
      this.passwordFieldValue[controlName] = event.target.value;
    }
    if (formName === "verify") {
      this.verifyPasswordFieldValue[controlName] = event.target.value;
    }
    let ispasswordFieldValueValid = false;
    for (const type in this.passwordFieldValue) {
      if (this.passwordFieldValue[type] === null) {
        ispasswordFieldValueValid = true;
      }
    }
    let isverifyPasswordFieldValueValid = false;
    for (const type in this.verifyPasswordFieldValue) {
      if (this.verifyPasswordFieldValue[type] === null) {
        isverifyPasswordFieldValueValid = true;
      }
    }
    if (ispasswordFieldValueValid || isverifyPasswordFieldValueValid) {
      return;
    }
    this.submitted = true;
    // Match each newPasswordInputBoxN against verifyPasswordInputBoxN.
    for (let i = 1; i <= 4; i++) {
      this.syncPasswordFieldMatchErrors(i);
    }
    // Reject all-zero and all-255 verify combinations.
    if (this.everyVerifyEquals(0)) {
      this.setAllVerifyErrors({ incorrect: true });
    } else {
      this.setAllVerifyErrors(null);
    }
    if (this.everyVerifyEquals(255)) {
      this.setAllVerifyErrors({ incorrect: true });
    } else {
      this.setAllVerifyErrors(null);
    }
    // group-level validator now handles all-zero and all-255 scenarios
    if (this.newPasswordForm.valid && this.verifyPasswordForm.valid) {
      const pass = [];
      for (const [key, value] of Object.entries(
        this.verifyPasswordFieldValue
      )) {
        pass.push(parseInt(this.verifyPasswordFieldValue[key]));
      }
      this.ngModelval["OwpPassword"] = pass;
      // this.featureData.owpInputError(false);
      // this.checkdfault();
      // this.sendowpdata();
    } else {
      //this.ngModelval["OwpPassword"] = [];
      // this.featureData.owpInputError(true);
      // this.checkdfault();
      // this.sendowpdata();
    }
  }

  get f() {
    return this.newPasswordForm.controls;
  }

  /**
   * For index i in 1..4: if newPasswordInputBoxi and verifyPasswordInputBoxi
   * are both non-empty and differ, mark both as `{incorrect: true}`; else
   * clear the error. Mirrors the four identical if-else blocks previously
   * inlined in onSubmit().
   */
  private syncPasswordFieldMatchErrors(i: number): void {
    const newKey = `newPasswordInputBox${i}`;
    const verifyKey = `verifyPasswordInputBox${i}`;
    const newVal = this.passwordFieldValue[newKey];
    const verifyVal = this.verifyPasswordFieldValue[verifyKey];
    if (newVal !== "" && verifyVal !== "" && newVal !== verifyVal) {
      this.newPasswordForm.get(newKey).setErrors({ incorrect: true });
      this.verifyPasswordForm.get(verifyKey).setErrors({ incorrect: true });
    } else {
      this.newPasswordForm.get(newKey).setErrors(null);
      this.verifyPasswordForm.get(verifyKey).setErrors(null);
    }
  }

  /** True iff every verifyPasswordInputBoxN parses to the given integer. */
  private everyVerifyEquals(target: number): boolean {
    for (let i = 1; i <= 4; i++) {
      if (parseInt(this.passwordFieldValue[`verifyPasswordInputBox${i}`]) !== Number(target)) {
        return false;
      }
    }
    return true;
  }

  /** Set (or clear) errors on all four verifyPasswordInputBoxN controls at once. */
  private setAllVerifyErrors(errors: LegacyAny): void {
    for (let i = 1; i <= 4; i++) {
      this.newPasswordForm.get(`verifyPasswordInputBox${i}`).setErrors(errors);
    }
  }

  sendPassword(){
    this.activeModal.close()
    this.sendOwpPwd.emit(this.passwordFieldValue)
  }

  onCancelClick() {
    this.cancelOwpPwd.emit();
    this.activeModal.close();
  }
  ngOnDestroy() {
    this.cancelOwpPwd.emit();
  }
}
